import { render, staticRenderFns } from "./BatchPrinting.vue?vue&type=template&id=4f918a2d&scoped=true"
import script from "./BatchPrinting.vue?vue&type=script&lang=js"
export * from "./BatchPrinting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f918a2d",
  null
  
)

export default component.exports